import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Cookie } from 'lucide-react';

const CONSENT_KEY = 'omg-cookie-consent';

export const CookieBanner = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(() => {
    try {
      return !localStorage.getItem(CONSENT_KEY);
    } catch {
      return false;
    }
  });

  if (!visible) return null;

  const accept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, 'accepted');
    } catch {
      // storage unavailable - dismiss for session only
    }
    setVisible(false);
  };

  return (
    <div
      className="no-print fixed bottom-0 inset-x-0 z-[90] px-4 pb-4 sm:px-6"
      role="region"
      aria-label="Cookie notice"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto rounded-xl border border-white/10 bg-[#001f54]/95 backdrop-blur-md shadow-xl p-4 sm:px-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <div className="flex items-start gap-3">
          <Cookie className="w-4 h-4 text-white/60 mt-0.5 shrink-0" aria-hidden="true" />
          <p className="text-sm text-white/80 leading-relaxed">
            {t('legal.cookie_banner_text')}{' '}
            <Link
              to="/cookies"
              className="text-white underline underline-offset-2 hover:text-white/90 transition-colors"
              data-testid="cookie-banner-policy-link"
            >
              {t('legal.cookie_banner_link')}
            </Link>
          </p>
        </div>
        <Button
          size="sm"
          onClick={accept}
          className="bg-white text-[#001f54] hover:bg-white/90 font-semibold shrink-0"
          data-testid="cookie-banner-accept-button"
        >
          {t('legal.cookie_banner_accept')}
        </Button>
      </div>
    </div>
  );
};
